<template>
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="h2">SMS</div>
            <div class="flash-message">
                <FlashMessage :position="'top'"></FlashMessage>
            </div>
            <div>
                <a :href="createTemplateUrl">
                    <button class="btn btn-primary">
                        Create SMS template
                    </button>
                </a>
            </div>
        </div>
        <div class="position-relative pagination-control table-hover mb-4">
            <data-table
                :columns="columns"
                :url="url"
                :per-page="perPage"
                :order-by="orderBy"
                :order-dir="orderDir"
                :debounce-delay=1000
                ref="table"
            >
                <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                <tr>
                    <th v-for="column in columns" style="min-width: 130px;">
                        <span> {{ column.label }} </span>
                    </th>
                </tr>
                </thead>
                <tbody slot="body" slot-scope="{ data }" class="table-bordered">
                <tr
                    :key="template.id"
                    v-for="template in data">
                    <td
                        :key="column.id"
                        v-for="column in columns"
                        class="laravel-vue-datatable-td"
                    >
                        <data-table-cell
                            :value="template"
                            :name="column.name">
                        </data-table-cell>

                        <slot v-if="column.id === 'active'">
                            <div>{{ template.active ? 'Yes' : 'No' }}</div>
                        </slot>

                        <slot v-if="column.id === 'send_to'">
                            <div>{{ sendToOptions[template.send_to] }}</div>
                        </slot>

                        <slot v-if="column.id === 'conditions'">
                            <div v-html="template.prettyConditions"></div>
                        </slot>

                        <slot v-if="column.id === 'actions'">
                            <span class="material-icons-outlined cursor-pointer mr-1 text-primary"
                                  @click="removeTemplate(template)"
                                  title="Remove template"
                            >delete</span>
                            <span class="material-icons-outlined cursor-pointer mr-1 text-primary"
                                  @click="showTemplate(template.id)"
                                  title="Edit template"
                            >edit</span>
                            <span class="material-icons-outlined cursor-pointer mr-1 text-primary"
                                  @click="triggerPrepareDataForSms(template)"
                                  title="Send SMS"
                            >sms</span>
                        </slot>

                    </td>
                </tr>
                </tbody>

            </data-table>
        </div>

        <sms-result-modal ref="smsResultModal"></sms-result-modal>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import SmsResultModal from "./reusable/SmsResultModal.vue";

export default {
    name: "SmsTemplateDataTable",
    components: {Loading, VueTimepicker, SmsResultModal},
    props: {
        url: {type: String, required: true},
        createTemplateUrl: {type: String, required: true},
        sendToOptions: {type: Array, required: true},
    },
    data() {
        return {
            isLoading: false,
            perPage: [25, 50, 100],
            orderBy: "id",
            orderDir: "desc",
            columns: [
                {
                    label: 'Title',
                    name: 'title',
                    id: 'title',
                    orderable: true,
                },
                {
                    label: 'Text',
                    name: 'text',
                    id: 'text',
                    orderable: false,
                },
                {
                    label: 'Conditions',
                    id: 'conditions',
                    orderable: false,
                },
                {
                    label: 'Send to',
                    id: 'send_to',
                    orderable: false,
                },
                {
                    label: 'Active',
                    id: 'active',
                    orderable: false,
                },
                {
                    label: 'Actions',
                    id: 'actions',
                    orderable: false,
                },
            ],
        }
    },
    methods: {
        removeTemplate(template) {
            if (confirm(`Are you sure you want to delete the template "${template.title}"?`)) {
                axios.delete(`/sms/templates/${template.id}`)
                    .then((response) => {
                        this.flashMessage.success({
                            title: '',
                            message: `Removed successfully!`,
                            time: 2000,
                            blockClass: 'flash-message'
                        });

                }).catch(err => {
                    this.flashError(err, `Template "${template.title}" has been removed.`);

                }).finally(() => {
                    this.$refs.table.getData();
                })

            }
        },
        showTemplate(id) {
            window.location.href = `/sms/templates/${id}`;
        },
        triggerPrepareDataForSms(template) {
            if (confirm(`Are you sure you want to sent an sms ${template.title}?`)) {
                this.$refs.smsResultModal.prepareDataForSms(template);
            }
        },
        flashError(error, defaultMassage = 'Error') {
            console.error(error.response);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data ||  defaultMassage,
                time: 4000,
                blockClass: 'flash-message error'
            });
        },
    }

}
</script>

<style scoped>

</style>
